import React, { useEffect, createElement } from 'react';
import { Routes, Route } from 'react-router-dom';
import { SalesPageV5 } from './pages/SalesPageV5';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
import { StickyReviewBar } from './components/StickyReviewBar';
export function App() {
  useEffect(() => {
    // UTMify UTMs script
    const utmifyScript = document.createElement('script');
    utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript.setAttribute('data-utmify-prevent-xcod-sck', '');
    utmifyScript.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript.async = true;
    utmifyScript.defer = true;
    document.head.appendChild(utmifyScript);
    (window as any).pixelId = '69a84f432f2498111cab00d3';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    // Google tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-H6W0NPCL3K';
    document.head.appendChild(gtagScript);
    const gtagInline = document.createElement('script');
    gtagInline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-H6W0NPCL3K');
    `;
    document.head.appendChild(gtagInline);
    // Google Tag Manager
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-558L5RR8');`;
    document.head.appendChild(gtmScript);
  }, []);
  return <Routes data-id="element-0" data-mp="38kvshhq5xim">
      <Route path="/" element={<>
            <StickyReviewBar data-id="element-2" data-mp="3ubrg6gs32a2e" />
            <SalesPageV5 data-id="element-3" data-mp="3ucjdpx58qhvb" />
            <RecentPurchaseToast priceOverrides={[{
        product: 'NutriPeques',
        price: '$15.90 USD',
        weight: 1
      }]} data-id="element-4" data-mp="d4nwrk0ubq3z" />
          </>} data-id="element-1" data-mp="3uct4hmy40t22" />
    </Routes>;
}